import type { FC } from "react";

export interface DraftMessageEmailLinkProps {
  email: string;
}

export const DraftMessageEmailLink: FC<DraftMessageEmailLinkProps> = ({ email }) => {
  const search = /<[^>]*>?/g;
  const emailAddress = email.match(search)?.[0].replaceAll(/[<>]/g, "");
  const name = email.replaceAll(search, "").trim();

  if (emailAddress) {
    return (
      <>
        {name}
        {` `}
        &lt;<a href={`mailto:${emailAddress}`}>{emailAddress}</a>&gt;
      </>
    );
  }

  return (
    <>
      &lt;<a href={`mailto:${email}`}>{email}</a>&gt;
    </>
  );
};
